export const GET_BAG = "GET_BAG";



// WEBPACK FOOTER //
// ./template/state/modules/miniBag/constants.js